import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const DealSourceForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'source'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'deal.source.general.name_label',
            type: 'text',
            placeholder: 'deal.source.general.name_placeholder',
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default DealSourceForm;